// DEV-08 批次作業的「指派位置」（ORG-04）：一個企業 home 一次請求、同一交易——有一項不行整批拒絕。
// 這裡只放跟畫面無關的部分：依 home 分組、把一個 home 的結果攤回每一台的列。
import type { BatchRow } from './batch';

export interface LocTarget {
  key: string;
  homeId: string;
  aid: string;
}

/** 依 home 分組（保持原本順序）。 */
export function groupByHome<T extends LocTarget>(items: T[]): Map<string, T[]> {
  const out = new Map<string, T[]>();
  for (const it of items) {
    const list = out.get(it.homeId) ?? [];
    list.push(it);
    out.set(it.homeId, list);
  }
  return out;
}

/**
 * 一個 home 的結果攤回列：成功 = 全部 ok（detail = 位置名稱）；失敗 = 出錯的那一台 failed（錯誤碼），
 * 同一批其他台 failed「BATCH_REJECTED」（整批沒套用）；不知道是哪一台時全部 failed（錯誤碼）。
 */
export function applyHomeResult<T extends LocTarget>(rows: BatchRow<T>[], group: T[], res: { ok: true; siteName: string } | { ok: false; code: string; index?: number }): void {
  const keys = new Set(group.map((g) => g.key));
  const bad = !res.ok && res.index !== undefined ? group[res.index]?.key : undefined;
  for (const r of rows) {
    if (!keys.has(r.item.key)) continue;
    if (res.ok) {
      r.state = 'ok';
      r.detail = res.siteName;
    } else {
      r.state = 'failed';
      r.detail = bad === undefined || bad === r.item.key ? res.code : 'BATCH_REJECTED';
    }
  }
}
